import React from "react";
const propsAreBarShapeFunctionProps = (props) => {
    const barShapeProps = props;
    return (typeof barShapeProps.fill === "string" &&
        typeof barShapeProps.x === "number" &&
        typeof barShapeProps.y === "number" &&
        typeof barShapeProps.width === "number" &&
        typeof barShapeProps.height === "number" &&
        (typeof barShapeProps.cursor === "undefined" ||
            typeof barShapeProps.cursor === "string"));
};
const BarWithRoundCorners = (props) => {
    if (!propsAreBarShapeFunctionProps(props)) {
        throw new Error(`Invalid bar shape function props: ${props}`);
    }
    const { fill, x, y, width, height, cursor } = props;
    const radius = 4;
    const right = x + width;
    const bottom = y + height;
    const path = `
    M${x},${bottom}
    L${x},${y + radius}
    Q${x},${y} ${x + radius},${y}
    L${right - radius},${y}
    Q${right},${y} ${right},${y + radius}
    L${right},${bottom}
    Z
  `;
    return React.createElement("path", { d: path, fill: fill, cursor: cursor });
};
export default BarWithRoundCorners;
//# sourceMappingURL=BarWithRoundCorners.js.map